// import barba from '@barba/core';
import { MenuGeoliance } from "./menu.js";
import { Home } from "./home.js";
import { Gallery } from "./gallery.js";
import { Animations } from "./animations.js";
import { Tabs } from "./tabs.js";
import { TextLoop } from "./text-loop.js";
import { ParallaxEffect } from "./parallax-effect.js";
import { Jobs } from "./jobs.js";
import { Expandables } from "./expandables.js";
import { VideoImageFullscreen } from "./video-image-fullscreen.js";
import { SinglePole } from "./single-pole.js";
import { Testimonials } from "./testimonials.js";
import { References } from "./references.js";
import { VideoStories } from "./video-stories.js";
import { StaggerHorizontal } from "./stagger-horizontal";
import { ProjectsSlider } from "./projects-slider";
import { AnimateOnScroll } from "./animate-on-scroll";
import StyledFileUpload from "./components/StyledInput.js";

(function () {
  "use strict";

  class Main {
    constructor() {
      // this.debug = true;
      let _self = this;

      const _menu = new MenuGeoliance();
      _menu.init();

      _self.setVU();
      window.addEventListener("resize", _self.setVU);

      function pageLoadScripts() {
        const _home = new Home();
        _home.init();

        const _parallaxEffect = new ParallaxEffect();
        _parallaxEffect.init();

        const _gallery = new Gallery();
        _gallery.init();

        const _animations = new Animations();
        _animations.init();

        const _tabs = new Tabs();
        _tabs.init();

        const _textLoop = new TextLoop();
        _textLoop.init();

        const _jobs = new Jobs();
        _jobs.init();

        const _expandables = new Expandables();
        _expandables.init();

        const _videoImageFullscreen = new VideoImageFullscreen();
        _videoImageFullscreen.init();

        const _singlePole = new SinglePole();
        _singlePole.init();

        const _testimonials = new Testimonials();
        _testimonials.init();

        const _references = new References();
        _references.init();

        const _videoStories = new VideoStories();
        _videoStories.init();

        const _staggerHorizontal = new StaggerHorizontal();
        _staggerHorizontal.init();

        const _projectsSlider = new ProjectsSlider();
        _projectsSlider.init();

        const _animateOnScroll = new AnimateOnScroll();
        _animateOnScroll.init();

        $(".js-modal-btn").each(function (i, el) {
          console.log(
            "js-modal-btn?",
            el,
            $(el).attr("data-video-id"),
            $(el).attr("href")
          );
          if (
            typeof $(el).attr("data-video-id") == "undefined" ||
            $(el).attr("data-video-id") == ""
          ) {
            $(el).attr(
              "data-video-id",
              _self.mkwvs_get_video_url_id($(el).attr("href"))
            );
          }
          $(el).modalVideo({
            channel: /\D/.test($(el).attr("data-video-id"))
              ? "youtube"
              : "vimeo",
          });
        });

        $(window).on("load", function (e) {
          $("html").removeClass("loading");
        });
      }

      pageLoadScripts();

      _self.setVU();

      const loadingPanel = $("#loading").appendTo(document.body);

      if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
      }

      let scrollX = 0;
      let scrollY = 0;

      barba.init({
        timeout: 20000,
        debug: _self.debug,
        logLevel: _self.debug ? "debug" : "off",
        transitions: [
          {
            name: "default-transition",
            leave(data) {
              loadingPanel.one("animationend webkitanimationEnd", function (e) {
                // loadingPanel.removeClass('is-entering');
              });

              loadingPanel.addClass("is-animated").addClass("is-entering");

              return gsap.to(data.current.container, 0, {
                delay: 0.25,
                opacity: 0,
                onComplete: function () {
                  if (_self.debug)
                    console.log("barba leave", ScrollTrigger.getAll());
                  let scrollTriggers = ScrollTrigger.getAll();
                  for (var i = 0; i < scrollTriggers.length; i++) {
                    if (_self.debug) console.log(scrollTriggers[i]);
                    // if(scrollTriggers[i].vars.id != 'headerScrollTrigger') scrollTriggers[i].kill(false);
                    scrollTriggers[i].kill(false);
                  }

                  // reset scroll
                  window.scrollTo(0, 0);
                  $("body").removeClass("has-scrolled-header");
                  $(".o-header").removeClass("is-hidden");

                  // close menus
                  window.MenuGeoliance.closeMenus();
                },
              });

              //clear Home autoplay check and muted check interval
              clearInterval(window.Home.autoplayCheck);
              window.Home.clearIntervalMuted();
            },
            enter(data) {
              $(document.body).attr(
                "class",
                $(data.next.container).data("barba-body_class")
              );

              // If we are on a Gravity Forms page, just reload it, to start its scripts.
              if (document.body.querySelector(".gform_wrapper")) {
                window.location.reload();
              }

              pageLoadScripts();

              return gsap.from(data.next.container, 0.1, {
                delay: 0.25,
                opacity: 0,
                onComplete: function () {
                  loadingPanel.one(
                    "animationend webkitanimationEnd",
                    function (e) {
                      loadingPanel
                        .removeClass("is-animated")
                        .removeClass("is-entering is-leaving");
                    }
                  );
                  loadingPanel.addClass("is-leaving");
                },
              });
            },
            after(data) {
              // console.log('barba after', ScrollTrigger.getAll());

              // init header ScrollTrigger
              window.MenuGeoliance.initHeaderScrollTrigger();

              // resize videos
              setTimeout(function () {
                window.VideoImageFullscreen._resize();
              }, 400);

              setTimeout(function () {
                // ScrollTrigger.refresh();
                let scrollTriggers = ScrollTrigger.getAll();
                if (_self.debug)
                  console.log("barba after scrolltriggers", scrollTriggers);
                for (var i = 0; i < scrollTriggers.length; i++) {
                  if (_self.debug)
                    console.log(
                      "barba after scrolltriggers refresh",
                      scrollTriggers[i]
                    );
                  if (scrollTriggers[i].vars.id != "headerScrollTrigger")
                    scrollTriggers[i].refresh();
                }
              }, 2000);
            },
          },
        ],
      });

      barba.hooks.leave(() => {
        // record scroll position
        scrollX = barba.history.current.scroll.x;
        scrollY = barba.history.current.scroll.y;
      });

      // anchor links smooth scroll
      $(document).on("click", 'a[href^="#"]:not([href="#"])', function (e) {
        e.preventDefault();
        e.stopPropagation();

        _self.scrollToTargetAdjusted($($(this).attr("href")));
      });

      //
    }

    mkwvs_get_video_url_id(url) {
      if (url.indexOf("youtu.be") > 0 || url.indexOf("youtube") > 0) {
        var regex =
          /(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i;
        var found = url.match(regex);
        return found[1];
      } else if (url.indexOf("vimeo") > 0) {
        var videoURL = new URL(url);
        return videoURL.pathname.substring(1);
      } else {
        return "unknown";
      }
    }

    setVU() {
      let vw = document.documentElement.clientWidth / 100;
      let vh = document.documentElement.clientHeight / 100;
      document.documentElement.style.setProperty("--vw", `${vw}px`);
      document.documentElement.style.setProperty("--vh", `${vh}px`);
      var styleElem = document.getElementById("styleVU");
      if (styleElem == null) {
        styleElem = document.head.appendChild(document.createElement("style"));
        styleElem.setAttribute("id", "styleVU");
      }
      styleElem.innerHTML =
        "::before, ::after {--vw: " + vw + "px;--vh: " + vh + "px;}";
    }

    scrollToTargetAdjusted(element) {
      let _self = this;

      // var headerOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      var headerOffset = 0;
      var elementPosition = element.offset().top;
      var offsetPosition = elementPosition - headerOffset;
      if (_self.debug) console.log("scrollToTargetAdjusted element", element);
      if (_self.debug)
        console.log("scrollToTargetAdjusted headerOffset", headerOffset);
      if (_self.debug)
        console.log("scrollToTargetAdjusted elementPosition", elementPosition);
      if (_self.debug)
        console.log("scrollToTargetAdjusted offsetPosition", offsetPosition);

      // gsap.to(window, {duration: 1.4, scrollTo: {y: offsetPosition, autoKill: true}, ease: "power2"});

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }

  const _main = new Main();

  const initFileInput = () => {
    StyledFileUpload.init({
      defaultText: "Ajouter un fichier",
      removeText: "Supprimer",
    });
  };
  initFileInput();

  // Reinit file input when gravity forms throws error.
  $(document).on("gform_post_render", initFileInput);

  document
    .querySelector("li.manage-cookies")
    .addEventListener("click", function () {
      const consentButton = document.getElementById(
        "seopress-user-consent-edit"
      );
      if (consentButton) {
        consentButton.dispatchEvent(
          new CustomEvent("click", { bubbles: true })
        );
        // Ensure the cookie banner becomes visible
        const cookieBanner = document.querySelector(
          ".seopress-user-consent.seopress-user-message.seopress-user-consent-hide"
        );
        if (cookieBanner) {
          cookieBanner.classList.remove("seopress-user-consent-hide");
        }
      }
    });
})();
